import { useRef } from "react";

export interface IModalProps {
  visible: boolean;
  onClose: () => void;
  mask?: boolean;
  children?: React.ReactNode;
  maskClosable?: boolean;
}

const Modal: React.FC<IModalProps> = ({
  visible,
  mask,
  onClose,
  maskClosable,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (maskClosable) {
      onClose();
    }
  };
  return (
    <>
      {visible && (
        <div className="w-full h-full">
          <div
            className={`fixed inset-0 flex items-center justify-center z-999 ${
              mask ? "bg-black bg-opacity-50" : ""
            }`}
            onClick={handleClickOutside}
          >
            <div ref={ref} onClick={(e) => e.stopPropagation()}>
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
